import type { FullPostType, StepType } from './types';

export const STEPS_CONFIG: Record<FullPostType, StepType[]> = {
	facebook_post: [
		{
			label: 'Your message is copied',
			variant: 'copied_link',
		},
		{
			label: 'Paste it into Facebook ',
			variant: 'paste',
		},
	],
	facebook_story: [
		{
			label: 'Tap the sticker icon',
			variant: 'sticker_icon',
		},
		{
			label: 'Tap ‘Link’ button',
			variant: 'link_sticker',
		},
		{
			label: 'Your link is copied',
			variant: 'copied_link',
		},
		{
			label: 'Paste link',
			variant: 'paste_url',
		},
	],
	facebook_group_post: [
		{
			label: 'Your message is copied',
			variant: 'copied_link',
		},
		{
			label: 'Paste it into Facebook ',
			variant: 'paste',
		},
	],
	instagram_post: [
		{
			label: 'Your message is copied',
			variant: 'copied_link',
		},
		{
			label: 'Paste it into Instagram',
			variant: 'paste',
		},
		{
			label: 'Add link to your bio',
			variant: 'link_in_bio',
		},
	],
	instagram_story: [
		{
			label: 'Tap the sticker icon',
			variant: 'sticker_icon',
		},
		{
			label: 'Tap ‘Link’ button',
			variant: 'link_sticker',
		},
		{
			label: 'Your link is copied',
			variant: 'copied_link',
		},
		{
			label: 'Paste link',
			variant: 'paste_url',
		},
	],
	reddit_post: [
		{
			label: 'Your message is copied',
			variant: 'copied_link',
		},
		{
			label: 'Paste it into Reddit',
			variant: 'paste',
		},
	],
	reddit_group_post: [
		{
			label: 'Your message is copied',
			variant: 'copied_link',
		},
		{
			label: 'Paste it into Reddit',
			variant: 'paste',
		},
	],
};
